class UserMenuLinks {
  constructor (accountLinks, logout, haveUnreadMessages, messengerLink, userIsBreeder, userIsGroomer, userIsTrainer) {
    this.accountLinks = accountLinks
    this.logout = logout
    this.haveUnreadMessages = haveUnreadMessages
    this.messengerLink = messengerLink
    this.userIsBreeder = userIsBreeder
    this.userIsGroomer = userIsGroomer
    this.userIsTrainer = userIsTrainer
  }

  commonItems () {
    return [
      {
        url: this.accountLinks.home,
        title: 'Dashboard Home'
      },
      {
        url: this.messengerLink,
        title: 'Messenger',
        unread: this.haveUnreadMessages
      }
    ]
  }

  logoutItem () {
    return (
      {
        onClick: () => this.logout(),
        title: 'Sign Out'
      }
    )
  }

  breederItems () {
    let items = this.commonItems()

    items.push({
      url: this.accountLinks.manage_listings,
      title: 'Manage Listings'
    })

    items.push({
      url: this.accountLinks.breeder_manage_my_page,
      title: 'Manage My Page'
    })

    items.push({
      url: this.accountLinks.buyer_questionnaire,
      title: 'My Buyer Questionnaire'
    })

    items.push({
      url: this.accountLinks.organization_public_url,
      title: 'My Page'
    })

    items.push(this.logoutItem())

    return items
  }

  groomerItems () {
    let items = this.commonItems()

    items.push({
      url: this.accountLinks.groomer_manage_my_page,
      title: 'Manage My Page'
    })

    items.push({
      url: this.accountLinks.organization_public_url,
      title: 'My Page'
    })

    items.push(this.logoutItem())

    return items
  }

  trainerItems () {
    let items = this.commonItems()

    items.push({
      url: this.accountLinks.trainer_manage_my_page,
      title: 'Manage My Page'
    })
    items.push(this.logoutItem())

    return items
  }

  userItems () {
    let items = this.commonItems()

    items.push({
      url: this.accountLinks.home + '#saved-searches',
      title: 'Saved Searches'
    })

    items.push(this.logoutItem())

    return items
  }

  getUserMenu () {
    let items = []

    if (this.userIsBreeder) {
      items = this.breederItems()
    } else if (this.userIsGroomer) {
      items = this.groomerItems()
    } else if (this.userIsTrainer) {
      items = this.trainerItems()
    } else {
      items = this.userItems()
    }

    return items
  }
}

export default UserMenuLinks
